(function () {
    Shop.FocusHandler.include({
        options: {
            focusElement: null,
            focusContainer: null,

            selectors: {
                focusContainer: '.js__focus-container'
            }
        },

        initialize: function (options) {
            this.constructor.setOptions(options);

            this.options.focusElement = options.element;
            this.options.focusContainer = this.options.focusElement.closest(this.options.selectors.focusContainer);

            if (!this.options.focusContainer) return;

            this._bindEvents(this);
        },

        _bindEvents: function (focusHandlerInstance) {
            focusHandlerInstance.options.focusElement.addEventListener('focus', () => {
                focusHandlerInstance.options.focusContainer.classList.add('focused');
            });

            focusHandlerInstance.options.focusElement.addEventListener('blur', () => {
                focusHandlerInstance.options.focusContainer.classList.remove('focused');
            });
        }
    });
})();
